// extracted by mini-css-extract-plugin
export default {"container":"components-Common-__styles__-IconText__container","icon":"components-Common-__styles__-IconText__icon","text":"components-Common-__styles__-IconText__text"};